// `action` defaults to 'link': older notifications never carried it.
export default function resolveNotificationAction(data) {
  const d = data || {};
  const action = d.action || 'link';

  if (action === 'action' && d.action_name) {
    const { action_name: actionName, ...payload } = d;
    return { type: 'action', actionName, payload };
  }

  const url = d.url || d.link;
  if (!url) return { type: 'none' };

  // `//host/path` is protocol-relative, so it leaves the admin like an absolute url.
  if (url.startsWith('/') && !url.startsWith('//')) return { type: 'route', path: url };

  return { type: 'link', url };
}
